module.exports = __webpack_public_path__ + "img/game_main_pc_239_off.fc919819.png";